// /dashboard/:orgSlug/documents — Figma frame 14 documents (33:1588).
// Owner: screens-content, US-120.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { DocumentsScreen } from "../screens/content/DocumentsScreen";

export const documentsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/documents",
  staticData: { title: "Documents" },
  component: DocumentsRoute,
});

function DocumentsRoute() {
  const { orgSlug } = documentsRoute.useParams();
  return (
    <DocumentsScreen orgSlug={orgSlug} />
  );
}
